export const ACHIEVEMENT_NAMES = {
    CONFIRM_EMAIL: 'confirm_email',
    DEPOSIT_FIRST: 'deposit_first',
    POSITION_CLOSE_FIRST: 'position_close_first',
    POSITION_CLOSE_FIRST_REAL: 'position_close_first_real', // unused
    POSITION_CLOSE_NEGATIVE_FIRST_REAL: 'position_close_negative_first_real', // unused
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_10: 'position_close_positive_at_row_real_10',
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_25: 'position_close_positive_at_row_real_25',
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_3: 'position_close_positive_at_row_real_3',
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_50: 'position_close_positive_at_row_real_50',
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_5: 'position_close_positive_at_row_real_5',
    POSITION_CLOSE_POSITIVE_AT_ROW_REAL_7: 'position_close_positive_at_row_real_7',
    POSITION_CLOSE_POSITIVE_DEMO_10: 'position_close_positive_demo_10',
    POSITION_CLOSE_POSITIVE_DEMO_20: 'position_close_positive_demo_20',
    POSITION_CLOSE_POSITIVE_DEMO_50: 'position_close_positive_demo_50',
    POSITION_CLOSE_POSITIVE_DEMO_5: 'position_close_positive_demo_5',
    POSITION_CLOSE_POSITIVE_FIRST_REAL: 'position_close_positive_first_real', // unused
    POSITION_CLOSE_REAL_1000: 'position_close_real_1000',
    POSITION_CLOSE_REAL_100: 'position_close_real_100',
    POSITION_CLOSE_REAL_10: 'position_close_real_10',
    POSITION_CLOSE_REAL_10K: 'position_close_real_10k',
    POSITION_CLOSE_REAL_500: 'position_close_real_500',
    POSITION_CLOSE_REAL_50: 'position_close_real_50',
    POSITION_CLOSE_REAL_5K: 'position_close_real_5k',
    TRADING_DAYS_AT_ROW_14: 'trading_days_at_row_14',
    TRADING_DAYS_AT_ROW_21: 'trading_days_at_row_21',
    TRADING_DAYS_AT_ROW_30: 'trading_days_at_row_30',
    TRADING_DAYS_AT_ROW_7: 'trading_days_at_row_7',
    VERIFIED: 'verified',
    VISIT_EVERY_DAY: 'visit_every_day',
} as const;

export const ACHIEVEMENT_TYPES = {
    ONCE: 'once',
    INCREMENT: 'increment',
    INFINITY: 'infinity',
} as const;

export const ACHIEVEMENT_STATUS = {
    CREATED: 'created',
    PROCESS: 'process',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
} as const;

export const ACHIEVEMENT_CATEGORIES = [
    {
        name: 'first_steps',
        title: 'achievements.categories.first_steps',
        pos: 1,
        achievements: [
            ACHIEVEMENT_NAMES.DEPOSIT_FIRST,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_FIRST,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_FIRST_REAL,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_FIRST_REAL,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_NEGATIVE_FIRST_REAL,
        ],
    }, {
        name: 'streak',
        title: 'achievements.categories.streak',
        pos: 2,
        achievements: [
            ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_7,
            ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_14,
            ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_21,
            ACHIEVEMENT_NAMES.TRADING_DAYS_AT_ROW_30,
        ],
    }, {
        name: 'real_power',
        title: 'achievements.categories.real_power',
        pos: 3,
        achievements: [
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_10,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_50,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_100,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_500,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_1000,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_5K,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_REAL_10K,
        ],
    }, {
        name: 'profit_pioneer',
        title: 'achievements.categories.profit_pioneer',
        pos: 4,
        achievements: [
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_3,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_5,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_7,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_10,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_25,
            ACHIEVEMENT_NAMES.POSITION_CLOSE_POSITIVE_AT_ROW_REAL_50,
        ],
    }, {
        name: 'other',
        title: 'achievements.categories.other',
        pos: 5,
        achievements: [
            ACHIEVEMENT_NAMES.CONFIRM_EMAIL,
            ACHIEVEMENT_NAMES.VERIFIED,
        ],
    },
] as const;

export const GAP_ACHIEVEMENT_ICON_PREVIEW = 20 as const;